export const environment = {
   production: false,
   API_KEY_IMAGE4IO: "undefined",
   API_SECRET_IMAGE4IO: "undefined",
   API_URL_IMAGE4IO: "undefined",
   NODE_VERSION: "v16.16.0",
   SITE_ID: "3cb99734-59d3-4f02-aa78-2fc00e43822a",
   API_KEY_NETLIFY: "AM1Xny5MrkpcjA49qWM45h3nJjiuqqwUAkpG5hR8vJs",
   URL: "https://kinderkultur.ch",
};